import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import useLenis from "../../lib/useLenis";
import { useFrameSnap, goToFrame } from "../../frames";

export const Layout = ({ children }) => {
  useLenis();
  useFrameSnap();
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return undefined; }
    // Deep link to a section (e.g. /contact#enquiry): go there once the frames are laid out,
    // and again after the late repack so a fresh page load lands on the right frame.
    const go = () => {
      const el = document.getElementById(hash.slice(1));
      if (!el) return;
      const frame = el.closest("[data-frame]");
      if (document.documentElement.classList.contains("snap-on") && frame) goToFrame(frame);
      else el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    const t1 = setTimeout(go, 150);
    const t2 = setTimeout(go, 1400);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [pathname, hash, key]);

  return (
    <div className="relative min-h-screen bg-[#0a0a0a]">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
